import { ComponentRef } from '@angular/core';
import { DataTableComponent } from '@farris/ui-datatable';
import { TreeNode, TreeTableComponent } from '@farris/ui-treetable';
import { UserFavoriteData } from '../http/RemoteParams';
import { FavoriteAction, FavoriteIcon, FAVORITE_FIELD_NAME, LookupGridDisplayType } from '../lookup-displaytype';
import { LookupGridResult } from '../lookup-grid-options';
import { LookupGridComponent } from '../lookup-grid.component';
import { LookupSelectionService } from './lookup-selection.service';

export class FavoriteHelper {

    private lookupSelectionSer: LookupSelectionService;

    constructor(private instance: LookupGridComponent) {
        this.lookupSelectionSer = this.instance.lookupSelectionSer;
    }

    getFavoriteColumns(): any[] {
        const columns = this.instance.gridOptions.columns.map(item => {
            const rtn = Object.assign({}, item);
            if (item.field === FAVORITE_FIELD_NAME) {
                rtn.formatter = () => FavoriteIcon.delete;
            }
            return rtn;
        });

        this.instance.initColumnWidth(columns, 'fav');
        return columns;
    }

    favoriteColumnFormatter = (v: any, data: any  ) => {
        const f =  v ? FavoriteIcon.yes : FavoriteIcon.no;
        if (this.instance.isTree()) {
            const id = data[this.instance.idField];
            if (id) {
                const tt = this.instance.componentRef.instance as TreeTableComponent;
                const rn = tt.findRowNode(id);
                if (rn) {
                    if (rn.node.selectable) {
                        return f;
                    } else {
                        return '';
                    }
                }
            }
        }
        return f;
    }

    initPersonalInfo() {
        if (this.instance.personalConfigService) {
            const controlID = this.instance.el.nativeElement.id || this.instance.controlId;
            if (!controlID) {
                this.instance.writeConsole('LookupGrid - æªè®¾ç½®ç»ä»¶id, æ¶èåè½å°ä¸è½æ­£å¸¸ï¼è¯·è®¾ç½®ç»ä»¶id.');
            }
            const pcstr = this.instance.getLookupBindingFields();
            this.instance.personalConfigService.controlID = controlID;
            this.instance.personalConfigService.personalConfigKey = pcstr;

            const conf = {
                displayType: this.instance.displayType,
                singleSelect: this.instance.singleSelect,
                idField: this.instance.idField,
                textField: this.instance.textField,
                mapFields: Object.assign({}, this.instance.mapFields || {})
            };

            this.instance.personalConfigService.initPersonalConf(conf);

            // ä¸ªæ§åéç½®çè®¢éäºä»¶å¤ç
            this.listenPersonalConfigHandler();
        }
    }

    /**
     * çå¬æ¶èTABé¡µä¸­ç¸å³äºä»¶ï¼
     * æ°æ®éä¸­ï¼åæ¶éä¸­ï¼ç§»é¤æ¶èï¼åå»äºä»¶
     */
    initFavoriteComponentEvent(cmpRef: ComponentRef<any>) {
        switch (this.instance.displayType) {
            case LookupGridDisplayType.NavList:
            case LookupGridDisplayType.NavTreeList:
            case LookupGridDisplayType.List: {
                const fdt = cmpRef.instance as DataTableComponent;
                fdt.remoteSort = false;
                fdt.selectedRow.subscribe(e => {
                    if (this.instance.singleSelect) {
                        this.lookupSelectionSer.clearSelections();
                    }
                    this.lookupSelectionSer.updateSelections(e.data);
                });
                fdt.unSelectRow.subscribe(e => {
                    this.lookupSelectionSer.unSelect(e.data[this.instance.idField]);
                });

                if (!fdt.singleSelect) {
                    fdt.checkAll.subscribe(e => {
                        this.lookupSelectionSer.updateSelections(fdt.data, e);
                    });
                }

                fdt.cellClick.subscribe((e: any) => {
                    if (e.col.field === FAVORITE_FIELD_NAME) {
                        e.event.stopPropagation();
                        // tslint:disable-next-line: no-string-literal
                        const classList = e.event.target['classList'];
                        if (classList.contains('f-lookup-unfavorite')) {
                            if (this.instance.items) {
                                this.instance.items.forEach(item => {
                                    if (item[this.instance.idField] === e.row[this.instance.idField]) {
                                        item[FAVORITE_FIELD_NAME] = false;
                                    }
                                });

                                const dt = this.instance.componentRef.instance as DataTableComponent;
                                if (dt) {
                                    dt.loadData({
                                        pageSize: this.instance.gridOptions.pageSize,
                                        pageIndex: this.instance.gridOptions.pageIndex,
                                        total: this.instance.gridOptions.total,
                                        data: this.instance.gridOptions.items
                                    });
                                }
                            }

                            this.instance.favoriteItems =
                                this.instance.favoriteItems.filter(n => n[this.instance.idField] !== e.row[this.instance.idField]);

                            this.lookupSelectionSer.updateFavoriteData(e.row, FavoriteAction.delete);
                        }
                    }
                });

                // åå»äºä»¶
                fdt.rowDblClick.subscribe((rowData: any) => {
                    if (this.instance.gridOptions.singleSelect) {
                        this.instance.selectItem(rowData);
                    }
                });
                break;
            }
            case LookupGridDisplayType.TreeList: {
                if (cmpRef) {
                    const ftt = cmpRef.instance as TreeTableComponent;
                    ftt.remoteSort = false;
                    // ftt.dblClickExpand = !this.instance.singleSelect; // ç¦ç¨åå»å±å¼èç¹
                    ftt.nodeSelected.subscribe(e => {
                        if (this.instance.singleSelect) {
                            this.lookupSelectionSer.clearSelections();
                        }
                        this.lookupSelectionSer.updateSelections(e.node.data);
                    });
                    ftt.nodeUnChecked.subscribe(e => {
                        if (e.nodes && e.nodes.length) {
                            this.instance.multiSelMgr.remove(e.nodes.map(n => n.id));
                        } else if (e && e.node && e.node.data && e.node.data.id) {
                            // const tt = this.instance.componentRef.instance as TreeTableComponent;
                            // tt.unSelectNode(e.node.data.id);
                            this.lookupSelectionSer.unSelect(e.node.data.id);
                        }
                    });

                    ftt.nodeChecked.subscribe( e => {
                        if (!this.instance.singleSelect) {
                            if (e.nodes && e.nodes.length) {
                                this.instance.multiSelMgr.updateSelections(e.nodes.map(n => n.data));
                            } else {
                                if (Array.isArray(e.node)) {
                                    this.instance.multiSelMgr.updateSelections(e.node.map(n => n.data));
                                } else {
                                    this.instance.multiSelMgr.updateSelections([e.node.data]);
                                }
                            }
                        }
                    });

                    ftt.cellClick.subscribe(row => {
                        if (row.col.field === FAVORITE_FIELD_NAME) {
                            row.event.stopPropagation();
                            const classList = row.event.target['classList'];
                            if (classList.contains('f-lookup-unfavorite')) {
                                const _this = this.instance;
                                (function every(items) {
                                    if (!items) {
                                        return;
                                    }
                                    let hasFinish = false;
                                    items.forEach(item => {
                                        if (hasFinish) {
                                            return;
                                        }
                                        if (item.data[_this.idField] === row.node[_this.idField]) {
                                            item.data[FAVORITE_FIELD_NAME] = false;
                                            hasFinish = true;
                                        } else if (item.children && item.children.length > 0) {
                                            every(item.children);
                                        }
                                    });
                                })(this.instance.items);
                                const tt = this.instance.componentRef.instance as TreeTableComponent;
                                tt.loadData(this.instance.items);

                                this.lookupSelectionSer.updateFavoriteData(row.node.data, FavoriteAction.delete);
                            }
                        }
                    });
                    ftt.dblClick.subscribe((treeNode: TreeNode) => {
                        if (this.instance.gridOptions.singleSelect && treeNode.selectable) {
                            if (this.instance.okButton) {
                                // this.instance.okButton.nativeElement.click();
                                this.instance.selectItem(treeNode.data); // tfs 649656
                            }
                        }
                    });

                    ftt.checkAll.subscribe( e => {
                        const data = e.instance.checkeds.map(n => n.data);
                        this.instance.multiSelMgr.updateSelections(data);
                        this.instance.checkedChange.emit({ data, isCheck: true  });
                    });
                    ftt.unCheckAll.subscribe(() => {
                        // this.instance.multiSelMgr.clear();
                        const nodeItems = ftt.state.rowNodes.map(n => n.node.data);
                        this.lookupSelectionSer.updateSelections(nodeItems, false);
                        this.instance.checkedChange.emit({ data: [], isCheck: false  });
                    });
                }
            }
        }
    }


    private getFavoritData() {
        if (this.instance.personalConf) {
            const favData = this.instance.personalConf.favorite;
            const _data = (favData && favData[this.instance.localService.localeId]) ? favData[this.instance.localService.localeId] : [];
            return _data;
        }
        return [];
    }

    getFavoritIds() {
        return this.getFavoritData();
    }

    _loadFavoriteData(data = null) {
        const fdt = this.instance.favoritesComponentRef.instance as DataTableComponent;
        this.loadFavoriteDatatable(fdt, data);
        fdt.cd.markForCheck();
        this.instance.closeLoading();
    }

    // å è½½æ¶ègridæ°æ®
    loadFavoritesData(res = null) {
        const favIds = this.getFavoritIds();
        switch (this.instance.displayType) {
            case LookupGridDisplayType.NavList:
            case LookupGridDisplayType.NavTreeList:
            case LookupGridDisplayType.List: {
                const fdt = this.instance.favoritesComponentRef.instance as DataTableComponent;
                if (this.instance.favoriteDataFrom === 'locale') {
                    if (res) {
                        this._loadFavoriteData(res.items);
                    } else {
                        // this.instance.httpMgr.getFavoriteData(favIds).subscribe(resData => {
                        //     if (resData) {
                        //         this._loadFavoriteData(resData.items);
                        //     }
                        //     this.instance.closeLoading();
                        // });
                    }
                } else {
                    const favData = this.getFavoritData();
                    this.loadFavoriteDatatable(fdt, res ? res.items : favData);
                }
                break;
            }
            case LookupGridDisplayType.TreeList: {
                if (this.instance.favoritesComponentRef && this.instance.favoritesComponentRef.instance instanceof TreeTableComponent) {
                    const ftt = this.instance.favoritesComponentRef.instance as TreeTableComponent;
                    this.bindFavTreetable(ftt);

                    if (this.instance.favoriteDataFrom === 'locale') {
                        if (res) {
                            this.loadFavoriteForTreeTable(res.items || [], ftt);
                        } else {
                            // this.instance.httpMgr.getFavoriteData(favIds).subscribe(resData => {
                            //     if (resData) {
                            //         const items = resData.items;
                            //         this.loadFavoriteForTreeTable(items, ftt);
                            //     }
                            //     this.instance.closeLoading();
                            // });
                        }
                    } else {
                        if (res) {
                            this.loadFavoriteForTreeTable(res.items, ftt);
                        }
                    }
                }
            }
        }
    }

    private loadFavoriteDatatable(fdt: DataTableComponent, data?: any) {
        if (data !== undefined) {
            this.instance.favoriteItems = data;
        }

        if (fdt.columns && !fdt.columns.length) {
            fdt.columns = this.instance.favoriteColumns;
        }

        fdt.loadData({
            total: 0,
            pageSize: 20,
            pageIndex: 1,
            data: this.instance.favoriteItems
        });


        this.instance.selectionMgr.selectCurrentValue();
        fdt.cd.detectChanges();
    }


    private bindFavTreetable(ftt: TreeTableComponent) {
        ftt.checkDeepNodes = true;
        ftt.allColumnsTitle = this.instance.allColumnsTitle;
        ftt.idField = this.instance.idField;

        const columns = this.instance.gridOptions.columns.filter(n => {
            return n.field !== "__nodespagerbar__";
        }).map(item => {
            const rtn: any = { ...item };
            if (item.field === FAVORITE_FIELD_NAME) {
                rtn.formatter = (v: any, data: any): any => {
                    const favids = this.getFavoritIds();
                    if (favids && favids.length) {
                        const index = favids.findIndex(el => el === data[this.instance.idField]);
                        if (index >= 0) {
                            return FavoriteIcon.delete;
                        }
                    }
                    return '';
                };
            }
            return rtn;
        });
        this.instance.initColumnWidth(columns, 'fav');
        this.instance.favoriteColumns = columns;
        ftt.columns = columns;


        if (this.instance.gridOptions.treeInfo) {
            ftt.onlySelectLeaf = this.instance.gridOptions.treeInfo.onlySelectLeaf;
        }

        if (!ftt.singleSelect) {
            ftt.checkOnSelect = true;
            ftt.selectOnCheck = true;
            ftt.showCheckbox = true;

            // å¯ç¨å¤éåï¼åæ¶å¯ç¨çº§èéæ©
            if (this.instance.enableCascade) {
                this.instance.ttEventMgr.cascadeValueChanged(this.instance.cascadeStatus);
            } else {
                ftt.cascadeCheck = false;
                ftt.cascadeDown = false;
                ftt.cascadeUp = false;
            }
        }
    }

    private checkNodeIsLeaf(nodes: any ) {
        if (nodes && nodes.length) {
            return nodes.map((node: TreeNode) => {
                if (node.hasOwnProperty("addtional")) {
                    node.selectable = !node["addtional"];
                }
    
                if (node.children && node.children.length) {
                    this.checkNodeIsLeaf(node.children);
                } else {
                    node.leaf = true;
                }
    
                return node;
            });
        }
        return nodes;
    }

    initFavoriteTreeData(items) {
        const treeInfo = this.instance.gridOptions.treeInfo;

        if (treeInfo && !treeInfo['treeDataIsInit']) {
            if (treeInfo.layerType.toLowerCase() === 'pathcode') {
                items = this.instance.lookupUtils.makeTree(items, treeInfo);
            } else {
                items = this.instance.lookupUtils.makeTreeWithParentID(
                    items,
                    '',
                    treeInfo.dataField ? `${treeInfo.dataField}.${treeInfo.parentField}`: treeInfo.parentField,
                    this.instance.idField
                );
            }
        }

        // return this.instance.checkNodeCanBeSelect(items, true);
        return this.checkNodeIsLeaf(items);
    }

    loadFavoriteForTreeTable(items, ftt: any) {
        items = this.initFavoriteTreeData(items);
        this.instance.favoriteItems = items;
        ftt.loadData(items);
        ftt.expandAll();
        this.instance.selectionMgr.selectCurrentValue();

        return items;
    }

    // æ´æ°åè¡¨ä¸­çæ¶èæ°æ®æ è¯
    updateFavoritesStatus(data: any[]) {

        if (!data || !this.instance.useFavorite) {
            return;
        }

        const favIds = this.getFavoritIds();

        if (favIds && favIds.length) {
            // å¤çæ°æ®åè¡¨ä¸­çæ¶èæ°æ®æ è¯
            if (this.instance.displayType !== LookupGridDisplayType.TreeList) {
                data.map(item => {
                    if (favIds && favIds.length && favIds.find(v => v === item[this.instance.idField])) {
                        item[FAVORITE_FIELD_NAME] = true;
                    }
                });
            } else {
                const _this = this.instance;
                (function each(_data) {
                    _data.forEach(item => {
                        if (favIds && favIds.length && favIds.find(v => v === item.data[_this.idField])) {
                            item.data[FAVORITE_FIELD_NAME] = true;
                        }
                        if (item.children && item.children.length > 0) {
                            each(item.children);
                        }
                    });
                })(data);
            }
        }
    }


    private _updateFavorites(value: any, action, data) {
        const localeID = this.instance.localService.localeId;
        this.instance.personalConf.favorite = this.instance.personalConf.favorite || {};
        const items = value.filter(n => !n['_addtional_']);
        const newVal = items.map(n => n[this.instance.idField]).filter(n => n !== null && n !== undefined);

        const favItems = this.instance.personalConf.favorite[localeID] || [];
        this.instance.personalConf.favorite[localeID] = Array.from(new Set([...favItems , ...newVal]));

        if (action === FavoriteAction.delete && data) {
            this.instance.personalConf.favorite[localeID] = this.instance.personalConf.favorite[localeID].filter(n => n !== data[this.instance.idField]);
        }

        return this.instance.personalConf.favorite[localeID];
    }

    // æ¶èæ°æ®ç®¡ç
    private listenPersonalConfigHandler() {
        this.lookupSelectionSer.favoriteItems$.subscribe(n => {
            if (!this.instance.favoritesComponentRef) {
                return;
            }

            const { items, action, data } = n;
            const favids = this._updateFavorites(items, action, data);

            this.instance.httpMgr.submitFavoriteData(action);

            if (this.instance.displayType === LookupGridDisplayType.List || this.instance.displayType.includes('NAV')) {
                const dt = this.instance.favoritesComponentRef.instance as DataTableComponent;
                this.loadFavoriteDatatable(dt, items);
            } else if (this.instance.displayType === LookupGridDisplayType.TreeList) {
                const ftt = this.instance.favoritesComponentRef.instance as TreeTableComponent;
                // const favids = items.map(d => d.id);
                this.instance.showLoading();
                this.instance.httpMgr.getData({ favoriteIds: favids }, 'fav').subscribe(resData => {
                    if (resData) {
                        const _items = resData.items;
                        this.loadFavoriteForTreeTable(_items, ftt);
                    } else {
                        this.instance.favoriteItems = [];
                        ftt.loadData([]);
                    }
                    this.instance.closeLoading();
                });
            }
        });
    }

}
